module.exports = __webpack_public_path__ + "img/EuclidEnercity-RegularItalic-WebS.08d8d1ce.svg";